<template>
   <div>
      <header id="header" class="header">
         <a href="http://www.murdoch.edu.au"><img src="//static.murdoch.edu.au/precedent/images/murdoch-logo-hoz-white.svg" class="logo" alt="Murdoch University logo"></a>

         <form action="//search.murdoch.edu.au/" method="get" :class="'searchbox mobile'+(searchOpen?' searchbox-open':'')" id="top-search" enctype="application/x-www-form-urlencoded">
            <label for="search" class="visuallyhidden">Enter Search Keywords </label>
            <input ref="searchInput" type="search" placeholder="Search the Site" title="search" name="q" id="search" class="searchbox-input" required>

            <button type="submit" class="searchbox-submit mobile-menu" value="x"></button>
            <span class="searchbox-icon" @click="clickSearch"><span :class="'fal fa-'+(searchOpen?'times':'search')"></span></span>
         </form>

         <!--   <button class="menu-btn"><span class="button-text">Menu</span><span class="fa fa-bars"></span> </button> -->

         <ul class="header-global-links" v-html="globalNav">
            <!--            {{>environment}}-->
            {{ globalNav }}
         </ul>

      </header>
      <div class="faux-header"></div>

      <div id="mobile-header" class="fixed-top">

         <nav class="navbar navbar-expand-lg navbar-dark bg-faded" id="mobile-header">

            <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#menu-container" aria-controls="menu" aria-expanded="true" aria-label="Toggle navigation">
               <span class="navbar-toggler-icon"></span>
            </button>

            <a href="http://www.murdoch.edu.au/" class="mobile-logo"><img src="//static.murdoch.edu.au/precedent/images/murdoch-logo-hoz-white.svg" alt="Murdoch University" height="56"></a>


            <button class="dropdown-toggle" type="button" id="mobile-site-search" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

            </button>


            <div class="dropdown-menu" aria-labelledby="mobile-site-search">

               <form action="//search.murdoch.edu.au/" method="get" class="searchbox mobile searchbox-open" id="bottom-search" enctype="application/x-www-form-urlencoded">
                  <label for="mobile-search" class="visuallyhidden">Enter Search Keywords </label>
                  <input type="search" placeholder="Search the Site" title="search" name="q" id="mobile-search" class="searchbox-input" required="">

                  <button type="submit" class="searchbox-submit mobile-menu" value="x"><span class="fal fa-search"></span></button>
               </form>

            </div>

            <div class="navbar-collapse collapse" id="menu" aria-expanded="true">
            </div></nav>

      </div>

      <div class="breadcrumb" v-if="breadcrumbs">
         <div class="container container-fluid">
            <Breadcrumbs />
         </div>
      </div>

      <div id="banner" v-if="showBanner">
         <div class="container container-fluid">
            <h1>{{appTitle}} <span v-if="appSubtitle" class="small">{{appSubtitle}}</span></h1>
         </div>
      </div>
      <div style="text-align: center; background-color: #fff3cd; font-weight: bold">VueJS Rendered Page</div>

      <div id="user-info">
         <div class="container container-fluid">
            <ul>
               <UserInfo />
            </ul>
         </div>
      </div>
   </div>
</template>

<script>
   import { mapState } from 'vuex'
   export default {
      data () {
         return {
            showBanner: true,
            searchOpen: false
         }
      },
      computed: {
         ...mapState({
            appTitle: state => state.global.appTitle,
            appSubtitle: state => state.global.appSubtitle,
            breadcrumbs: state => state.global.breadcrumbs,
            globalNav: state => state.global.chunks['global-nav']
         })
      },
      methods: {
         clickSearch() {
            this.searchOpen = !this.searchOpen
            if (this.searchOpen)
               this.$refs.searchInput.focus()
         }
      }
   }
</script>

<style>
</style>
